import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  InputAdornment,
  Box,
  Stack
} from '@mui/material';
import { Fragment } from 'react';
import NumberFormat from 'react-number-format';
import useLanguage from 'src/hooks/Language/useLanguage';
import { useCurrencyRate } from 'src/hooks/Settings/CurrencyRate/useCurrencyRate';
import ButtonColor from 'src/components/Forms/Buttons';

const CurrencyRateTable = () => {
  const { register, fields, queryCurrencyRateFromSource, saveCurrencyRateMutation, handleSubmit, handleFormSubmit } =
    useCurrencyRate();
  const { language } = useLanguage();

  return (
    <>
      <Box className="py-[15px] float-right" alignItems="right" justifyContent="space-between" display="flex">
        <Stack spacing={2} direction="row" className="h-24 self-center">
          <ButtonColor
            type="button"
            className="px-16"
            color="danger"
            onClick={() => queryCurrencyRateFromSource.mutate()}
            btnTitle={'Update From VCB'}
          />
          <ButtonColor
            isFetchingData={saveCurrencyRateMutation.isLoading}
            type="button"
            onClick={() => handleSubmit(handleFormSubmit)()}
            className="px-16"
            color="success"
            btnTitle={language.common.buttons.save}
          />
        </Stack>
      </Box>

      <TableContainer sx={{ maxHeight: 650 }}>
        <form className="form">
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell align="left">Ngoại tệ</TableCell>
                <TableCell align="center">Tỷ giá</TableCell>
              </TableRow>
              <TableRow></TableRow>
            </TableHead>
            <TableBody>
              {fields.map((item, index) => (
                <Fragment key={item.id}>
                  <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell>{item.code}</TableCell>
                    <TableCell align="center">
                      <NumberFormat
                        {...register(`currencyRates.${index}.rate`)}
                        customInput={TextField}
                        placeholder="To VND"
                        thousandSeparator
                        variant="standard"
                        value={item.rate}
                        InputProps={{
                          startAdornment: <InputAdornment position="start">VND</InputAdornment>
                        }}
                      />
                    </TableCell>
                  </TableRow>
                </Fragment>
              ))}
            </TableBody>
          </Table>
        </form>
      </TableContainer>
    </>
  );
};
export default CurrencyRateTable;
